import { Card } from '@client/new/components/Card';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { Typography } from '../../../../design-system/components/typography/typography';

export const InfoTip = (p: React.PropsWithChildren) => (
  <Card
    variant="basic"
    withoutBg
    rounded="lg"
    className="flex flex-row"
    style={{
      backgroundColor: '#E5F6FD',
      display: 'flex',
      alignItems: 'flex-start',
    }}
  >
    <div className="flex items-start gap-2 mr-[8px] mt-[4px]">
      <FontAwesomeIcon color="#448AF7" icon={faInfoCircle} />
    </div>
    <Typography variant="body" size="large" fontWeight="normal">
      {p.children}
    </Typography>
  </Card>
);
